// @flow
import * as React from 'react';
import Modal from 'app/common/components/Modal';
import Button from 'app/common/ui/Button';
import { Trans } from 'react-i18next';

import StudentsSelector from 'app/components/StudentsSelector';
import enhance from 'app/containers/ElJur/enhanceElJurLogin';
// import ElJurConforms from './ElJurConforms';
import ElJurGoTo from './ElJurGoTo';
import styles from './ElJurDnevnik.scss';


type Props = {
  tokenData: {
    isSaved: boolean,
    token: string,
    vendor: string,
  },
  ejLoginUrl: string,
  error: string,
  isLogin: boolean,
  handleShowLogin: (e: SyntheticEvent<HTMLElement>) => void,
  handleCloseLogin: (e: SyntheticEvent<HTMLElement>) => void,
  children: any,
};

const ElJurDnevnik = ({
  // isSubscribe не нужен, если дневник внешний -- он поддерживается в любом случае
  // Вместо этого -- токен, получаемый с сервера или из окна логина
  tokenData: { isSaved, token, vendor },
  ejLoginUrl,
  error,
  isLogin,
  handleShowLogin,
  handleCloseLogin,
  // children,
}: Props) =>

  <div>
    <StudentsSelector />
    {error && <p className={styles.error}>{error}</p>}

    {(!token || !vendor || !isSaved) && !error
      && <p>
        <Trans i18nKey="eljur:login_please">
          Для продолжения требуется залогиниться в сервис Элжур
        </Trans>
      </p>}

    {(error || !token || !vendor || !isSaved)
      && <Button onClick={handleShowLogin} style={{ magrinRight: 10 }}>
        <Trans i18nKey="eljur:show_login_bt">
          Показать окно логина
        </Trans>
      </Button>
    }

    {isLogin
      && <Modal className={styles.modal} overlayClassName={styles.overlay}>
        <Button onClick={handleCloseLogin} className={styles.modalClose}>
          <Trans i18nKey="eljur:close_bt">
            Закрыть
          </Trans>
        </Button>
        <iframe src={ejLoginUrl} width="980" height="620" frameBorder="0" title="eljur" />
      </Modal>}

    {isSaved && <ElJurGoTo className={styles.gotoLink} />}

    {/* Здесь должен был быть дневник с данными  Элжура и подтверждением соответствия учеников, */}
    {/* если бы их не удалось сопоставить автоматически */}
    {/* <ElJurConforms>
      {!!vendor && !!token && children}
    </ElJurConforms> */}
  </div>;


export default enhance(ElJurDnevnik);
